import type {FinalCheckPaymentData, OtpPaymentState} from './types';
import type {CpcBuyFilters, CpcBuyStep} from 'modules/Cpc/Buy/types';

import {dateToReadableDate} from '@date-picker';
import CpcInfoRow from 'modules/Cpc/components/common/CpcInfoRow/CpcInfoRow';
import {useNavigate} from 'react-router-dom';
import {numberFormat} from 'utils/Helper';

import OtpPaymentSheet from './components/OtpPaymentSheet/OtpPaymentSheet';

type FinalCheckStepProps = {
  filters: CpcBuyFilters;
  steps: CpcBuyStep[];
  query: URLSearchParams;
  payment: FinalCheckPaymentData;
  otpPayment: OtpPaymentState;
};

const FinalCheckStep: React.FC<FinalCheckStepProps> = ({
  filters,
  steps,
  query,
  payment,
  otpPayment
}) => {
  const navigate = useNavigate();
  const price = Number(filters.price ?? 0);
  const click = Number(filters.click ?? 0);
  const taxAmount = (price * click * Number(payment.taxRate)) / 100;
  const oneThird = payment.maxPrice / 3;
  const priority = price > oneThird * 2 ? 'بالا' : price > oneThird ? 'متوسط' : 'پایین';
  const totalPrice = price > 0 && click > 0 ? price * click + taxAmount : 0;

  return (
    <>
      <div className="flex min-h-0 flex-1 flex-col justify-between">
        <div>
          <p className="p-4 text-body-sm text-neutral-fg">
            جزئیات کلیک خود را بررسی و در صورت صحیح بودن آن را «ایجاد» کنید.
          </p>
          <CpcInfoRow title="نام کمپین" value="کمپین کلیک" />
          <CpcInfoRow title="تعداد کلیک" value={String(filters.click ?? '')} />
          <CpcInfoRow title="اولویت تخمینی" value={priority} />
          <CpcInfoRow
            title="زمان شروع"
            value={dateToReadableDate({
              date: filters.date ?? '',
              day: true,
              month: true,
              year: true
            })}
            onEdit={() => navigate(`/cpc/buy/${steps[0].key}?${query}`)}
          />
        </div>
        {price > 0 && click > 0 ? (
          <div>
            <CpcInfoRow title="مبلغ فاکتور" value={`${numberFormat(price * click)} تومان`} />
            <CpcInfoRow
              title={`مالیات ${payment.taxRate}٪ درصد`}
              value={`${numberFormat(taxAmount)} تومان`}
            />
            <CpcInfoRow title="جمع کل" value={`${numberFormat(totalPrice)} تومان`} />
          </div>
        ) : null}
      </div>
      <OtpPaymentSheet
        show={otpPayment.isOpen}
        onClose={otpPayment.onClose}
        otp={otpPayment.otp}
        setOtp={otpPayment.setOtp}
        countDown={otpPayment.countDown}
        setCountDown={otpPayment.setCountDown}
        vendorNumber={payment.vendorNumber}
        totalPrice={totalPrice}
        confirmPaymentLoading={payment.confirmPaymentLoading}
        resendOtp={otpPayment.onResend}
        finalizePayment={otpPayment.onFinalize}
      />
    </>
  );
};

export default FinalCheckStep;
